<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="gift-box">
        <div
          v-for="(item, key) in giftData.list"
          :key="key"
          class="gift-item"
        >
          <div class="top" :data-text="item.name">{{ item.name }}</div>
          <div class="image">
            <img :src="getGiftImg(item.icon)" />
          </div>
          <div class="name">{{ item.rewardName }}</div>
          <div class="reward-btn reward-btn--finish" v-if="item.status"></div>
          <div class="reward-btn reward-btn--enable" @click="getReward(item)" v-else-if="item.finish"></div>
          <div class="reward-btn" v-else></div>
        </div>
      </div>
      <div class="bottom">
        <div class="text">
          <template v-if="stage == 0">您已邀请<span>{{ inviteCount[2] }}</span>人预约</template>
          <template v-if="stage == 1">您已邀请<span>{{ inviteCount[2] }}</span>人预约，已邀请<span>{{ inviteCount[3] }}</span>人下载</template>
        </div>
        <div class="btn-group">
          <div class="invite-btn" @click="invite"></div>
          <div class="gift-btn" @click="openBag" v-if="stage == 1"></div>
        </div>
        <div class="rule" @click="openRuleDialog">活动规则</div>
      </div>
      <div class="character"></div>
    </div>
    <invitation-dialog :visible.sync="invitationDialogVisible" />
    <prize-dialog :prizeList="giftLog" :visible.sync="prizeDialogVisible" @success="handlePrizeSuccess" />
  </div>
</template>

<script>
import InvitationDialog from './components/InvitationDialog.vue'
import PrizeDialog from '@/views/pc/components/prizeDialog/Index.vue'

import invitationMixins from '@/mixins/home/invitationMixins.js'

export default {
  name: 'PcHomeInvitation',
  mixins: [invitationMixins],
  components: {
    InvitationDialog,
    PrizeDialog,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/pc/btns.scss';

.module {
  height: 1009px;

  &__title {
    background-position: center -576px;
  }

  &__content {
    position: absolute;
    left: 50%;
    transform: translateX(-240px);
    margin-top: 52px;
    width: 834px;
    height: 419px;
  }
}

.gift-box {
  display: flex;
  justify-content: space-between;
}

.gift-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 254px;
  height: 419px;
  background: url('~@/assets/img/pc/gift_bg2.png') no-repeat;

  .top {
    margin-top: 50px;
    font-family: Noto Serif SC;
    font-size: 30px;
    font-weight: 700;
    letter-spacing: 1px;
    color: transparent;
    -webkit-text-stroke: 5px #f3e8d1;

    &::before {
      content: attr(data-text);
      position: absolute;
      background-image: linear-gradient(180deg, #a83e22, #d67147);
      background-clip: text;
      color: transparent;
      -webkit-text-stroke: 0;
    }
  }

  .image {
    display: flex;
    align-items: center;
    margin-top: 32px;
    width: 105px;
    height: 105px;

    img {
      width: 100%;
    }
  }

  .name {
    margin-top: 28px;
    width: 100%;
    height: 48px;
    text-align: center;
    color: #613811;
    font-size: 16px;
    white-space: pre-wrap;
  }

  .reward-btn {
    margin-top: 6px;
    width: 188px;
    height: 53px;
    background: $btnsBackgroud;
    background-position: $invitationGiftBtnDisablePos;

    &--finish {
      background: url('~@/assets/img/pc/invitation_btn.png') no-repeat;
    }

    &--enable {
      background-position: $invitationGiftBtnPos;
      cursor: pointer;

      &:hover {
        background-position: $invitationGiftBtnActivePos;
      }
    }
  }
}

.bottom {
  position: absolute;
  top: 460px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;

  .text {
    margin-bottom: 12px;
    color: #6a5b52;
    font-size: 20px;

    span {
      margin: 0 8px;
      color: #b22e2e;
      font-size: 30px;
      font-weight: bold;
    }
  }
  
  .rule {
    margin-top: 12px;
    font-size: 20px;
    color: #3479a5;
    cursor: pointer;
    
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #3479a5;
    }
  }
}

.btn-group {
  display: flex;

  .invite-btn {
    width: 311px;
    height: 76px;
    background: $btnsBackgroud;
    background-position: $invitationBtnPos;
    cursor: pointer;
  
    &:hover {
      background-position: $invitationBtnActivePos;
    }
  }

  .gift-btn {
    margin-left: 40px;
    width: 315px;
    height: 76px;
    background: url('~@/assets/img/pc/gift_btn.png') no-repeat;
    cursor: pointer;
  }
}

.character {
  position: absolute;
  z-index: -1;
  left: -722px;
  top: -274px;
  width: 982px;
  height: 997px;
  background: url('~@/assets/img/pc/character2.png') no-repeat;
}
</style>